import apiClient from "./api";

export const checkUser = async (email) => {
    const response = await apiClient.post(`/api/Accounts/check`, { email });
    return response.data;
}

